import styled from 'styled-components'
import { CardHeader as MuiCardHeader } from '@material-ui/core'

export const CardHeader = styled(MuiCardHeader)`
  padding-left: 0;
  padding-right: 0;
`
